export const TOGGLE_TOGGLE_MODAL = 'TOGGLE_TOGGLE_MODAL';

export function toggleToggleModal(
  objectIdToToggle = '',
  toggleTrueText = '',
  toggleFalseText = '',
  paramToToggle = {},
) {
  return {
    type: TOGGLE_TOGGLE_MODAL,
    payload: {
      objectIdToToggle,
      toggleTrueText,
      toggleFalseText,
      paramToToggle,
    },
  };
}
